// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.AccessPolicyTableRow-module-pendingDeleteRow {
  opacity: 0.5;
}

td.AccessPolicyTableRow-module-actionCell > section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/AccessPolicyTableRow/AccessPolicyTableRow.module.css"],"names":[],"mappings":";AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":["\r\n.pendingDeleteRow {\r\n  opacity: 0.5;\r\n}\r\n\r\ntd.actionCell > section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n}"],"sourceRoot":""}]);
// Exports
export var pendingDeleteRow = `AccessPolicyTableRow-module-pendingDeleteRow`;
export var actionCell = `AccessPolicyTableRow-module-actionCell`;
export default ___CSS_LOADER_EXPORT___;
